import React from 'react'
import { Table } from 'components'
import { STORAGE_KEYS } from 'src/constants'
import { ClientTypes } from 'types'
import { RouteComponentProps, withRouter } from 'react-router-dom'

interface Props extends RouteComponentProps<any> {
    items: ClientTypes.Client[],
    onSelect: Function
}

class ClientsTable extends React.Component<Props> {

    constructor(props: Props) {
        super(props)
    }

    public handleClick = (client: ClientTypes.Client) => {
        localStorage.setItem(STORAGE_KEYS.CLIENT, JSON.stringify(client))
        this.props.onSelect(client)
    }

    public render() {

        const generateColumns = [
            {
                header: 'Customer number',
                accessor: 'id',
                cell: (cellInfo: any) => (
                    <div>
                        <small>{cellInfo.id}</small>
                    </div>
                )
            },
            {
                header: 'Company name',
                accessor: 'name',
                cell: (cellInfo: any) => <small>{cellInfo.name}</small>
            }
        ]

        return (
            <Table
                variant="secondary"
                data={this.props.items}
                columns={generateColumns}
                onRowClick={this.handleClick}
            />
        )
    }
}

export default withRouter(ClientsTable)



// WEBPACK FOOTER //
// ./src/components/ClientsTable/index.tsx